import api from './api';

export const partesService = {
  listar:    (idSiniestro)       => api.get(`/siniestros/${idSiniestro}/partes`),
  crear:     (idSiniestro, data) => api.post(`/siniestros/${idSiniestro}/partes`, data),
  actualizar:(idSiniestro, id, data) => api.put(`/siniestros/${idSiniestro}/partes/${id}`, data),
  eliminar:  (idSiniestro, id)   => api.delete(`/siniestros/${idSiniestro}/partes/${id}`),
};
